import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { SessionService } from '@core/core.module';
import { Roles } from '@core/helpers/all-roles';
import { TenantService } from '@core/tenant/tenant.service';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { NgxPermissionsService } from 'ngx-permissions';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssignmentsGuard implements CanActivate {
  constructor(
    private tenantService: TenantService,
    private permission: NgxPermissionsService,
    private session: SessionService,
    private router: Router
  ) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.session.userInfo$.pipe(
      distinctUntilChanged(),
      map(u => {
        const currentPath = route.routeConfig?.path;
        if(this.permission.getPermission(Roles.Admin) || this.permission.getPermission(Roles.NetworkAdmin)) {
          return true;          
        }
        else if (this.permission.getPermission(Roles.TreatmentProviderRepresentative) && this.tenantService.currentTenant.clinicAccessToAssignments) {
          if(u.treatmentProviderEmployees[0]?.appointmentScheduleEnabled && currentPath === 'appointment-schedules') {
            return true;
          }
          if(!u.treatmentProviderEmployees[0]?.appointmentScheduleEnabled && currentPath === 'assignments') {
            return true;
          } 
        }
        this.router.navigate(['/']);
        return false;
      })
    )
  }
}
